import request from '@/utils/request';

/**
 * 获取特殊商品列表
 * @param params
 * @returns
 */
export const getGoods = (params: any) =>
  request({
    url: '/api/v1/omc/special_good/list',
    method: 'get',
    params,
  });

/**
 * 查询特殊商品详情
 * @param id
 * @returns
 */
export const showGoods = (id: number) =>
  request({
    url: '/api/v1/omc/special_good?id=' + id,
    method: 'get',
  });

/**
 * 启用/禁用特殊商品
 * @param data
 * @returns
 */
export const updateGoods = (data: { id: number; open: boolean }) =>
  request({
    url: '/api/v1/omc/special_good/open',
    method: 'put',
    data,
  });

/**
 * 创建特殊商品
 * @param data
 * @returns
 */
export const addGoods = (data: any): Promise<any> =>
  request({
    url: '/api/v1/omc/special_good',
    method: 'post',
    data,
  });
